import { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';

/**
 * Check if an element is in viewport

 * @param {number} offset - Number of pixels up to the observable element from the top
 * @param {number} throttleMilliseconds - Throttle observable listener, in ms
 */
const useVisibility = (
    offset = 0,
    throttleMilliseconds = 100
) => {
    const [isVisible, setIsVisible] = useState(false);
    const currentElement = useRef();

    const onScroll = throttle(() => {
        if (!currentElement.current) {
            setIsVisible(false);

            return;
        }
        const { top } = currentElement.current.getBoundingClientRect();

        setIsVisible(top + offset >= 0 && top - offset <= window.innerHeight);
    }, throttleMilliseconds);

    useEffect(() => {
        document.addEventListener('scroll', onScroll, true);

        return () => document.removeEventListener('scroll', onScroll, true);
    });

    return [isVisible, currentElement];
};

export default useVisibility;

useVisibility.propTypes = {
    offset: PropTypes.number,
    throttleMilliseconds: PropTypes.number,
};